import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdminComponent } from './layout/admin/admin.component';
import { AuthComponent } from './layout/auth/auth.component';

const routes: Routes = [
  {
    path: '',
    component: AdminComponent,
    children: [
      {
        path: '',
        redirectTo: 'inicio',
        pathMatch: 'full'
      },
      {
        path: 'login',
        redirectTo: '/authentication/login',
        pathMatch: 'full'
      },
      {
        path: 'inicio',
        loadChildren: () => import('./pages/inicio/inicio.module').then(m => m.InicioModule)
      },
      {
        path: 'administracion',
        loadChildren: () => import('./pages/admin/admin.module').then(m => m.AdminModule)
      },
      {
        path: 'inventario',
        loadChildren: () => import('./pages/inventario/inventario.module').then(m => m.InventarioModule)
      },
      {
        path: 'inventarioCobradores',
        loadChildren: () => import('./pages/inventarioUsuario/inventarioUsuario.module').then(m => m.InventarioUsuarioModule)
      },
      {
        path: 'corte',
        loadChildren: () => import('./pages/corte/corte.module').then(m => m.CorteModule)
      },
      {
        path: 'cobros',
        loadChildren: () => import('./pages/cobros/cobros.module').then(m => m.CobrosModule)
      },
      {
        path: 'recuperacion',
        loadChildren: () => import('./pages/recuperacion/recuperacion.module').then(m => m.RecuperacionModule)
      },
      {
        path: 'reportes',
        loadChildren: () => import('./pages/reportes/reportes.module').then(m => m.ReportesModule)
      },
      {
        path: 'zonaCobro',
        loadChildren: () => import('./pages/admin/zonaCobro/zonaCobro.module').then(m => m.ZonaCobroModule)
      }, {
        path: 'perfil',
        loadChildren: () => import('./pages/user/perfil/perfil.module').then(m => m.PerfilModule)
      },
      {
        path: 'ventas',
        loadChildren: () => import('./pages/ventas/ventas.module').then(m => m.VentasModule)
      },
      {
        path: 'venta',
        loadChildren: () => import('./pages/ventas/detalleVenta/detalleVenta.module').then(m => m.DetalleVentaModule)
      },
      {
        path: 'compras',
        loadChildren: () => import('./pages/cobros/ventasCliente/ventasCliente.module').then(m => m.VentasClienteModule)
      },{
        path: 'adeudos',
        loadChildren: () => import('./pages/adeudos/adeudos.module').then(m => m.AdeudosModule)
      },
      {
        path: 'conectados',
        loadChildren: () => import('./pages/conectados/conectados.module').then(m => m.ConectadosModule)
      },
      {
        path: 'logger',
        loadChildren: () => import('./pages/logger/logger.module').then(m => m.LoggerModule)
      }
    ]
  },
  {
    path: '',
    component: AuthComponent,
    children: [
      {
        path: 'authentication',
        loadChildren: () => import('./pages/auth/auth.module').then(m => m.AuthModule)
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule { }

